import React, { useState } from "react";
import { useDispatch } from "react-redux";
import SwitchButton from "../../../components/commons/SwitchBtn";
import { getPromoteurs } from "../../../redux/actions/promoteursActions";
import { openModal } from "../../../redux/actions/modalActions";
import EditPromoteurModal from "./EditPromoteurModal";
import { deepSearchFunction } from "../../../redux/actions/immobilierActions";
import { useNavigate } from "react-router-dom";
import OrigineIcon from "../../../components/commons/OrigineIcon";

const PromoteursAdminBody = ({
  listePromoteurs,
  secteurs,
  onSort,
  sortConfig: parentSortConfig,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [activeMenuId, setActiveMenuId] = useState(null);

  const toggleMenu = (id, e) => {
    e.stopPropagation();
    setActiveMenuId(activeMenuId === id ? null : id);
  };

  const handleVisibilityToggle = () => {
    dispatch(
      getPromoteurs(
        1,
        25,
        "",
        parentSortConfig.field,
        parentSortConfig.direction,
        false,
      ),
    );
  };
  const handleDotsClick = (promoteur) => {
    dispatch(
      openModal({
        title: `${promoteur.id} | ${promoteur.name}` || "Promoteur",
        content: (
          <EditPromoteurModal
            promoteur={promoteur}
            secteurs={secteurs}
            sortConfig={parentSortConfig}
          />
        ),
      }),
    );
  };

  const handlePromoteurSearch = async (promoteur) => {
    try {
      // promoteur search
      await dispatch(
        deepSearchFunction(
          { promoteur: [promoteur.id] },
          "promoteur",
          promoteur.id,
          promoteur.name,
        ),
      );
    } catch (error) {
      console.error("Error during search:", error);
    } finally {
      navigate("/immobilier");
    }
  };

  // Function to handle sort request
  const requestSort = (key) => {
    let direction = "asc";
    if (
      parentSortConfig.field === key &&
      parentSortConfig.direction === "asc"
    ) {
      direction = "desc";
    }

    // Map UI keys to API field names
    let sortField = key;
    if (key === "visibility") {
      sortField = "visibility";
    } else if (key === "name") {
      sortField = "name";
    } else if (key === "origine") {
      sortField = "origine";
    }

    // Call the parent's onSort function
    onSort(sortField, direction);
  };

  // Helper function to render sort indicator
  const getSortIndicator = (key) => {
    // Map API field names to UI keys
    let uiKey = key;

    if (parentSortConfig.field !== key) {
      return <img src="/icons/sorts.svg" alt="sort" className="sort-icon" />;
    }
    return parentSortConfig.direction === "asc" ? (
      <img
        src="/icons/sort_up.svg"
        alt="sort ascending"
        className="sort-icon"
      />
    ) : (
      <img
        src="/icons/sort_down.svg"
        alt="sort descending"
        className="sort-icon"
      />
    );
  };

  return (
    <div>
      <div className="table mt-4">
        {/* Header */}
        <div className="table-catalogue-header pink ">
          <div
            className="table-cell-catalogue sortableHeaderStyle"
            onClick={() => requestSort("visibility")}
          >
            Visible {getSortIndicator("visibility")}
          </div>
          <div
            className="table-cell-catalogue sortableHeaderStyle"
            onClick={() => requestSort("name")}
          >
            Promoteur {getSortIndicator("name")}
          </div>
          <div className="table-cell-catalogue">Stock disponible</div>
          <div
            className="table-cell-catalogue sortableHeaderStyle"
            onClick={() => requestSort("origine")}
          >
            Origine {getSortIndicator("origine")}
          </div>
          <div className="table-cell-catalogue">Mandat</div>
          <div className="table-cell-catalogue">Tag</div>
          <div className="table-cell-catalogue"></div>
        </div>

        {/* List */}
        {listePromoteurs?.data ? (
          listePromoteurs.data.map((promoteur) => {
            const totalLots = promoteur.programmes_inclu.reduce(
              (sum, programme) => sum + (programme.lots?.length || 0),
              0,
            );

            return (
              <div
                key={promoteur.id}
                className="table-catalogue-row pointer position-relative"
                onClick={() => handlePromoteurSearch(promoteur)}
              >
                <div
                  style={{
                    position: "absolute",
                    left: "-20px",
                    top: "-10px",
                  }}
                >
                  <OrigineIcon origin={promoteur.api_listes?.[0]} />
                </div>
                <div
                  className="table-cell-catalogue"
                  onClick={(e) => e.stopPropagation()}
                >
                  <SwitchButton
                    isActive={promoteur.visibility}
                    itemId={promoteur.documentId}
                    onToggle={handleVisibilityToggle}
                    endpoint="api/promoteurs"
                    fieldName="visibility"
                  />
                </div>
                <div className="table-cell-catalogue text-start">
                  <img
                    src={
                      promoteur.logo?.url
                        ? process.env.REACT_APP_IMAGE_END_POINT +
                          promoteur.logo.url
                        : "./assets/imgNotFound.webp"
                    }
                    alt="Promoteur Logo"
                    height={96}
                    width={96}
                    style={{ borderRadius: "15px", objectFit: "contain" }}
                  />
                  <span>{promoteur.name}</span>
                </div>
                <div className="table-cell-catalogue d-flex flex-column text-start">
                  <span>{promoteur.programmes_inclu.length} programmes</span>
                  <span>{totalLots} lots</span>
                </div>
                <div className="table-cell-catalogue text-capitalize">
                  {promoteur.origine}
                </div>
                <div className="table-cell-catalogue">
                  {promoteur.mandat || "--"}
                </div>
                <div className="table-cell-catalogue">
                  {promoteur.tag || "--"}
                </div>
                <div className="dotsMenu" onClick={(e) => e.stopPropagation()}>
                  <button
                    className="border-0 bg-none p-2"
                    onClick={(e) => toggleMenu(promoteur.id, e)}
                  >
                    <img
                      src="./icons/dots-menu.svg"
                      alt="menu"
                      height={25}
                      width={25}
                    />
                  </button>
                  {activeMenuId === promoteur.id && (
                    <div className="dots-menu-modal border">
                      <div
                        className="dots-menu-item"
                        onClick={(e) => handlePromoteurSearch(promoteur)}
                      >
                        Voir les lots
                      </div>
                      <div
                        className="dots-menu-item"
                        onClick={(e) => handleDotsClick(promoteur)}
                      >
                        Modifier
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })
        ) : (
          <div className="text-center">Pas de promoteurs Correspondants</div>
        )}
      </div>
    </div>
  );
};

export default PromoteursAdminBody;
